import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NoteForm from '../../../components/forms/NoteForm';
import { useNoteApi } from '../../../hooks/useNoteApi';
import { useNavigate } from 'react-router-dom';
import { NoteDTO } from '../../../services/apiClient';

const NoteCreate: React.FC = () => {
  const { create, isLoading } = useNoteApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Notes', href: '/admin/notes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: NoteDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/notes');
    } catch (error) {
      console.error('Error creating Note:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/notes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Note.Edit'
    >
        <NoteForm
          initialValues={{} as NoteDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/notes')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default NoteCreate;